import { Component, Input, ElementRef, ViewChild, NgZone } from '@angular/core';
import { map } from 'lodash';
import { Content } from 'ionic-angular';

export interface ItemModel {
  id: any;
  title: String;
}
@Component({
  selector: 'flx-doclist',
  templateUrl: 'flx-doclist.html',
})
export class FlxDoclistComponent {
  @Input() docuData;
  public itemsData: Array<ItemModel>;
  public currentSelectedItem: number = 0;
  public currentSelectedItem2: number = 0;
  @ViewChild(Content) content: Content;
  constructor(public elementRef: ElementRef, public ngZone: NgZone) {
  }

  ngOnInit() {
    const items = this.elementRef.nativeElement.querySelectorAll('h1');

    this.itemsData = map(items, (item, index) => { return { id: index, title: item['textContent'] } });
  }

  scrollTo(elementId) {
    const title = this.getTitlesPosition()[elementId];

    this.content.scrollTo(0, title, 1000).then(e => {
      this.currentSelectedItem = elementId;
    });;
  }

  getTitlesPosition() {
    const titles = this.elementRef.nativeElement.querySelectorAll('h1');

    return map(titles, title => {
      return title['offsetTop']
    })
  }
  isScrolling(event) {
    if (!event) return;

    const currentTop = event.scrollTop;
    const titles = this.getTitlesPosition();

    titles.forEach((titleY, index) => {
      if (currentTop >= titleY) {
        this.ngZone.run(() => {
          this.currentSelectedItem = index;
        });
      }
    });


  }
}



// WEBPACK FOOTER //
// ./src/components/flx-doclist/flx-doclist.ts